import _extends from "@babel/runtime/helpers/extends";
/**
 * @name darcula
 * @author darcula
 * Name: IntelliJ IDEA darcula theme
 * From IntelliJ IDEA by JetBrains
 */
import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';
export var defaultSettingsDarcula = {
  background: '#2B2B2B',
  foreground: '#f8f8f2',
  caret: '#FFFFFF',
  selection: 'rgba(255, 255, 255, 0.1)',
  selectionMatch: 'rgba(255, 255, 255, 0.2)',
  gutterBackground: 'rgba(255, 255, 255, 0.1)',
  gutterForeground: '#999',
  gutterBorder: 'transparent',
  lineHighlight: 'rgba(255, 255, 255, 0.1)'
};
export var darculaDarkStyle = [{
  tag: [t.atom, t.number],
  color: '#bd93f9'
}, {
  tag: [t.comment],
  color: '#61A151'
}, {
  tag: [t.string],
  color: '#6A8759'
}, {
  tag: [t.variableName, t.operator],
  color: '#A9B7C6'
}, {
  tag: [t.meta, t.className],
  color: '#A9B7C6'
}, {
  tag: [t.propertyName],
  color: '#FFC66D'
}, {
  tag: [t.keyword],
  color: '#CC7832'
}, {
  tag: [t.tagName],
  color: '#ff79c6'
}, {
  tag: [t.typeName],
  color: '#ffb86c'
}];
export var darculaInit = options => {
  var _ref = options || {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'dark' : _ref$theme,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? [] : _ref$styles;
  return createTheme({
    theme: theme,
    settings: _extends({}, defaultSettingsDarcula, settings),
    styles: [...darculaDarkStyle, ...styles]
  });
};
export var darcula = darculaInit();